import { createSelector } from '@reduxjs/toolkit';

import {
  getFromImmutableStateCompatible,
  getImmutableCompatible,
} from 'src/utils/immutableUtils';
import { getExploreFiltersForQueryString } from 'src/utils/filtersUtils';

export const getFilters = (state) => getImmutableCompatible(state, 'filters');
export const getPlainFilters = getFromImmutableStateCompatible(getFilters);

export const getAllFiltersDisabled = createSelector(
  getPlainFilters,
  (filters) => filters.all_disabled,
);

export const getFilter = createSelector(
  [getPlainFilters, (_, filterName: string) => filterName],
  (filters, filterName) => filters[filterName],
);

export const getMinPrice = createSelector(
  (state) => getFilter(state, 'prices'),
  (prices) => (prices ? prices.min : null),
);

/**
 * Используется для формирования query-параметров при переходе
 * на страницу отеля
 */
export const getOfferFilters = createSelector(getPlainFilters, (filters) =>
  getExploreFiltersForQueryString(filters),
);
